<input
  type="date"
  class="date-input"
  [value]="value()"
  [disabled]="disabled()"
  [attr.min]="min()"
  [attr.max]="max()"
  (input)="onInput($event)"
/>
